module.exports = __webpack_public_path__ + "img/Saint-Barthelemy.ec9d43bf.png";